"use strict";

exports.__esModule = true;
exports.getElementsInPath = getElementsInPath;
/**
 * Return a list of all the elements in a path.
 */
function getElementsInPath(root, path) {
  var parents = [];
  var subject = root;
  if (!Array.isArray(subject) && typeof subject.type === "string") {
    parents.push(subject);
  }
  for (var i = 0; i < path.length; i++) {
    var key = path[i];
    subject = subject[key];
    if (subject == null) {
      break;
    }
    if (!Array.isArray(subject) && typeof subject.type === "string") {
      parents.push(subject);
    }
  }
  return parents;
}